import React, { useEffect, useRef, useState } from 'react'
import {
  Input,
  Modal,
  Select, TableColumnType,
} from 'antd'
import { EditableList } from '../../../compnents/list/EditableList'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
}
const { Option } = Select

const { TextArea } = Input

export const LisModal = (props: {
  name?: string
  visible: boolean
  onOk: () => void
  onCancel: () => void
  tableData:any
}) => {
  const inputRef = useRef<Input>(null)

  const dispatch = useDispatch<RootDispatch>()


  const [pageLoading, setPageLoading] = useState(false)

  const [countTotal, setCountTotal] = useState<any>('')


  const columns = (): TableColumnType<any>[] => {

    const column: TableColumnType<any>[] = [
      {
        title: '序号',
        key: 'no',
        width: '3rem',
        align: 'center',
        render: (_1, _2, index) => `${index + 1}`,
      },
      {
        title: '项目名称',
        dataIndex: '项目名称',
        width: '10rem',
        align: 'left',
        ellipsis: true,
        key: '项目名称',
        render: (_, r) => {
          return r?.项目名称 || '-'
        },
      },
      {
        title: '检验结果',
        width: '4rem',
        dataIndex: '检验结果',
        align: 'left',
        ellipsis: true,
        key: '检验结果',
        render: (_, r) => {
          let min = r?.最小参考值;
          let max = r?.最大参考值;
          let my = r?.检验结果;
          //非数字，校验文本
          if(!isNaN(my)){
            min = Number(min);
            max = Number(max);
            my = Number(my);
          }
          if(min && max && !isNaN(my)){
            if(my < min){
              return <span style={{fontWeight:"bold",color:"blue"}}>{my}&nbsp;<span style={{color:"blue"}}> ↓</span></span>
            }else if(my> max){
              return <span style={{fontWeight:"bold",color:"red"}}>{my}&nbsp;<span style={{color:"red"}}> ↑</span></span>
            }else{
              return r.检验结果;
            }
          }else if(min && !max && max != 0){
            if(my == min){
              return my
            }else{
              return <span style={{color:"red",fontWeight:"bold"}}>my</span>
            }
          }else if(!min && min !=0 && max){
            if(my == max){
              return my
            }else{
              return <span style={{color:"red",fontWeight:"bold"}}>my</span>
            }
          }else{
            return my || '-';
          }
        },
      },
      {
        title: '单位',
        dataIndex: '单位',
        width: '4rem',
        align: 'center',
        key: '单位',
        render: (_, r) => {
          return r?.单位 || '-'
        },
      },

      {
        title: '参考范围',
        dataIndex: '参考范围',
        width: '6rem',
        align: 'center',
        key: '参考范围',
        render: (_, r) => {
          if(r?.最小参考值 && r?.最大参考值){
            return (r?.最小参考值 +"~"+r?.最大参考值 );
          }else if(r?.最小参考值 && !r?.最大参考值){
            return r?.最小参考值;
          }else if(!r?.最小参考值 && r?.最大参考值){
            return r?.最大参考值;
          }else{
            return '-'
          }
        },
      },
      {
        title: '审核医生',
        dataIndex: '审核医生',
        width: '5rem',
        align: 'center',
        key: '审核医生',
        render: (_, r) => {
          return r?.审核医生 || 0
        },
      },

      {
        title: '审核时间',
        dataIndex: '审核时间',
        width: '7rem',
        align: 'center',
        key: '审核时间',
        render: (_, r) => {
          return r?.审核时间 || 0
        },
      },

    ]

    return column
  }
  return (
    <div>
      <Modal
        width='1000px'
        title={(props?.name ? props?.name : ' ') + '的检验报告'}
        visible={props.visible}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          props.onCancel()
        }}
        footer={null}
      >
        <EditableList
          style={{ height: '550px', overflow: 'hidden' }}
          scroll={{ y: '500px' }}
          loading={pageLoading}
          columns={columns()}
          pagination={false}
          page={{
            current: 1,
            size: 10,
            total: props.tableData?.length,
            items: props.tableData,
          }}
        />
      </Modal>
    </div >
  )
}

